import { EVatType } from '../../../../shared/types/EVatType';

export default [
  {
    text: 'НДС включен',
    value: EVatType.Included,
  },
  {
    text: 'Без НДС',
    value: EVatType.NotIncluded,
  },
  {
    text: 'УСН (упрощенная система налогообложения)',
    value: EVatType.Usn,
  },
];
